export const errorCodeSummary = (builder) => ({
    errorCodeSummary: builder.mutation({
        query: ({ page, limit, campaignType, search, startDate, endDate }) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
            return {
                url: '/errorCodeSummary',
                method: 'GET',
                params: { page, limit, campaignType, search, startDate, endDate  },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
            };
        },
    }),
});